import * as service from './services'
import to from 'await-to-js'

export const state = {
  nomeUsuario: null
}

export const getters = {
  nomeUsuario: state => state.nomeUsuario
}

export const mutations = {
  setNomeUsuario (state, payload) {
    state.nomeUsuario = payload
  }
}

export const actions = {
  setNomeUsuario ({commit}, payload) {
    commit('setNomeUsuario', payload)
  },

  async saveUserDrAchei ({dispatch}, payload) {
    dispatch('setLoading', true)
    const [error, response = {data: null}] = await to(service.save(payload))
    dispatch('setLoading', false)

    if (error) {
      if (error.response.data.code === 11000) {
        dispatch('showErrorMsg', {
          response: {
            status: 400,
            data: {
              message: 'Usuário existente, escolha outro nome de Usuário'
            }
          }
        })
        return Promise.reject(error)
      }
      dispatch('showErrorMsg', error)
      return Promise.reject(error)
    }

    return response.data
  },

  async ativarUser ({dispatch}, payload) {
    dispatch('setLoading', true)
    const [error, response = {data: null}] = await to(service.ativar(payload))

    dispatch('setLoading', false)
    if (error) {
      dispatch('showErrorMsg', error)

      return Promise.reject(error)
    }

    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/user/index.js